import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import is from '@sindresorhus/is';
import MatchRowTeaserProgressBar from 'app/components/matchRow/teaser/MatchRowTeaserProgressBar';
const Container = styled.div.withConfig({
  componentId: "sc-1oytyz5-0"
})(["position:relative;display:flex;max-width:", ";width:", ";justify-content:space-between;"], SIZES['46'], SIZES['46']);
const Result = styled.div.withConfig({
  componentId: "sc-1oytyz5-1"
})(["border-radius:", ";justify-content:center;max-width:1.375rem;width:1.375rem;height:", ";text-align:center;background-color:", ";"], SIZES['4'], SIZES['30'], props => {
  var _props$color;
  return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : COLORS.lighterGrey;
});
var ResultTypographyVariant = /*#__PURE__*/function (ResultTypographyVariant) {
  ResultTypographyVariant["RESULT"] = "result";
  ResultTypographyVariant["RESULT_RUNNING"] = "result-running";
  return ResultTypographyVariant;
}(ResultTypographyVariant || {});
const FallbackGoal = '-';
const MatchResult = _ref => {
  let {
    matchResult,
    color,
    className,
    allowLive
  } = _ref;
  const isLive = useMemo(() => allowLive && matchResult.isLive(), [allowLive, matchResult]);
  const progress = useMemo(() => isLive ? matchResult.getLiveProgress() : undefined, [isLive, matchResult]);
  const showProgressBar = isLive && is.number(progress) ? /*#__PURE__*/React.createElement(MatchRowTeaserProgressBar, {
    progress: progress
  }) : null;
  const getGoal = useCallback(goal => /*#__PURE__*/React.createElement(Result, {
    color: color
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: isLive ? ResultTypographyVariant.RESULT_RUNNING : ResultTypographyVariant.RESULT
  }, goal !== null && goal !== void 0 ? goal : FallbackGoal)), [color, isLive]);
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-sentry-element": "Container",
    "data-sentry-component": "MatchResult",
    "data-sentry-source-file": "MatchResult.tsx"
  }, getGoal(matchResult.result.homeGoal), getGoal(matchResult.result.awayGoal), showProgressBar);
};
export default MatchResult;